import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  LuBuilding2,
  LuCheck,
  LuChevronsUpDown,
  LuMenu,
  LuSettings,
} from "react-icons/lu";
import "./debitNote.css";

export default function DebitNoteResponsiveHeader({
  organisation = "Invoice & Recover",
  role = "Owner",
}) {
  const [organisationOpen, setOrganisationOpen] = useState(false);
  const organisationRef = useRef(null);
  const initials = (organisation || "Invoice & Recover")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  useEffect(() => {
    if (!organisationOpen) return undefined;
    const closeOnOutsideClick = (event) => {
      if (!organisationRef.current?.contains(event.target))
        setOrganisationOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOrganisationOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [organisationOpen]);

  const closeMenu = () => setOrganisationOpen(false);

  return (
    <div className="debit-tablet-nav" aria-label="Business navigation">
      <div className="debit-tablet-brand">
        <button
          type="button"
          aria-label="Open navigation"
          onClick={() =>
            window.dispatchEvent(new CustomEvent("open-dashboard-navigation"))
          }
        >
          <LuMenu aria-hidden="true" />
        </button>
        <span>invoice &amp; recover</span>
      </div>
      <div className="debit-organisation-wrap" ref={organisationRef}>
        <button
          type="button"
          className="debit-organisation-switcher"
          aria-label="Select organisation"
          aria-haspopup="menu"
          aria-expanded={organisationOpen}
          onClick={() => setOrganisationOpen((current) => !current)}
        >
          <span className="debit-organisation-avatar">{initials || "IR"}</span>
          <span className="debit-organisation-copy">
            <strong>{organisation}</strong>
            <small>{role}</small>
          </span>
          <LuChevronsUpDown aria-hidden="true" />
        </button>
        {organisationOpen && (
          <div
            className="debit-organisation-menu"
            role="menu"
            aria-label="Select organisation"
          >
            <button
              className="is-current"
              type="button"
              role="menuitemradio"
              aria-checked="true"
              onClick={closeMenu}
            >
              <LuBuilding2 aria-hidden="true" />
              <span>
                {organisation} · {role}
              </span>
              <LuCheck aria-hidden="true" />
            </button>
            <Link to="/MyProfile" role="menuitem" onClick={closeMenu}>
              <LuSettings aria-hidden="true" />
              <span>Business settings</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
